<template>
  <div class="member-center">
    <!-- 页面标题和批量操作 -->
    <div class="section-header">
      <div class="headerLeft">
        <span class="line"></span>
        我的收藏
      </div>
      <div class="batch-operation">
        <!-- 非批量模式显示批量操作按钮 -->
        <el-button type="primary" size="small" @click="toggleBatchMode" v-if="!isBatchMode">批量操作</el-button>

        <!-- 批量模式显示全选和取消收藏按钮 -->
        <div v-else>
          <template>
            <el-checkbox v-model="isAllSelected" @change="handleAllSelect" style="margin-right: 10px;">全选</el-checkbox>
            <span style="margin-right: 10px;">全选</span>
          </template>
          <el-button type="danger" size="small" @click="handleBatchDelete"
            :disabled="selectedItems.length === 0">取消收藏</el-button>
          <el-button type="text" size="small" @click="toggleBatchMode" style="margin-left: 10px;">取消</el-button>
        </div>
      </div>
    </div>

    <!-- 收藏商品网格 -->
    <div class="favorites-grid" v-if="favoriteItems.length > 0">
      <div class="favorite-card" v-for="(item, index) in favoriteItems" :key="item.goods_aid"
        @click="handleClick(item)">
        <!-- 批量模式下显示选择圆圈 -->
        <div v-if="isBatchMode" class="select-circle-wrapper">
          <el-checkbox class="hide-checkbox-label" v-model="selectedItems" :label="item.goods_aid"
            @change="handleItemSelect"></el-checkbox>
        </div>

        <div class="product-image">
          <img :src="item.goods_thumb" :alt="item.name">
        </div>
        <div class="product-info">
          <div class="product-name">{{ item.goods_name }}</div>
          <div class="product-price">
            <div>
              <span class="price-symbol">¥</span>
              <span class="price-value">{{ item.goods_shop_price }}</span>
              <span class="price-unit">{{ item.unit }}</span>
            </div>
            <div class="product-sales">销量{{ item.goods_sales }}</div>
          </div>
        </div>
      </div>
    </div>

    <div v-else>
      <el-empty description="暂无收藏商品"></el-empty>
    </div>


    <!-- 分页控件 -->
    <div class="pagination-container">
      <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="currentPage"
        :page-sizes="[10, 20, 50, 100]" :page-size="pageSize" layout="total, sizes, prev, pager, next, jumper"
        :total="totalOrders">
      </el-pagination>
    </div>


  </div>
</template>

<script>
export default {
  name: 'MyFavorites',
  data() {
    return {
      favoriteItems: [],

      // 批量操作相关数据
      isBatchMode: false, // 是否处于批量操作模式
      selectedItems: [], // 选中的商品ID列表
      isAllSelected: false, // 是否全选

      // 分页数据
      currentPage: 1,
      pageSize: 10,
      totalOrders: 0,
    }
  },
  mounted() {
    // 组件挂载时获取我的收藏列表
    this.getMyCollectionList();
  },
  methods: {

    // 处理点击事件 - 跳转到商品详情页
    handleClick(item) {
      // 跳转到商品详情页，传递商品ID作为参数
      this.$router.push({
        path: 'ShopDetails',
        query: {
          id: item.goods_aid
        }
      });
    },

    // 切换批量操作模式
    toggleBatchMode() {
      this.isBatchMode = !this.isBatchMode;
      if (!this.isBatchMode) {
        // 退出批量模式时清空选择
        this.selectedItems = [];
        this.isAllSelected = false;
      }
    },

    // 处理单个商品选择 - 默认多选模式
    handleItemSelect() {
      // 当没有商品时，直接返回
      if (this.favoriteItems.length === 0) {
        this.isAllSelected = false;
        return;
      }

      // 更新全选状态：当选中的商品数量等于所有商品数量时，全选状态为true
      this.isAllSelected = this.selectedItems.length === this.favoriteItems.length;
    },

    // 处理全选 - 实现真正的全选功能
    handleAllSelect() {
      if (this.isAllSelected) {
        // 全选：将所有商品的aid添加到selectedItems数组
        this.selectedItems = this.favoriteItems.map(item => item.goods_aid);
      } else {
        // 取消全选：清空selectedItems数组
        this.selectedItems = [];
      }
    },

    // 批量取消收藏
    handleBatchDelete() {
      if (this.selectedItems.length === 0) {
        return;
      }

      // 这里可以添加批量取消收藏的API调用
      console.log('批量取消收藏的商品ID:', this.selectedItems);

      this.cancelCollection(this.selectedItems.toString())
      // 模拟API调用成功后，从列表中移除选中的商品

    },

    // 取消收藏  
    cancelCollection(aid) {
      let data = {
        goods_id: aid,
      }
      this.$api.cancelCollection(data).then(res => {
        if (res) {
          // 取消收藏成功后，从列表中移除该商品
          this.favoriteItems = this.favoriteItems.filter(item => !this.selectedItems.includes(item.goods_aid));
          this.selectedItems = [];
          this.isAllSelected = false;
          this.$message({
            message: '取消收藏成功',
            type: 'success',
          });
        } else {
          this.$message({
            message: res.msg || '取消收藏失败',
            type: 'error',
          });
        }
      })
    },

    // 获取我的收藏列表
    getMyCollectionList() {
      let data = {
        page: this.currentPage,
        list_rows: this.pageSize,
      }
      this.$api.getMyCollectionList(data).then(res => {
        this.favoriteItems = res.data || [];
        this.totalOrders = res.total || 0;
      }).catch(err => {
        this.$message.error(err.msg);
        console.log(err);
      })
    },

    // 分页方法
    handleSizeChange(val) {
      this.pageSize = val;
      this.getMyCollectionList();
    },
    handleCurrentChange(val) {
      this.currentPage = val;
      this.getMyCollectionList();
    },
  }
}
</script>

<style scoped>
.member-center {
  background-color: #ffffff;
}

/* 页面标题 */
.section-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 24px;
}

.headerLeft {
  display: flex;
  align-items: center;
  font-size: 18px;
  font-weight: 600;
  color: #333333;
}

.line {
  display: block;
  width: 4px;
  height: 18px;
  background-color: #286CED;
  border-radius: 2px;
  margin-right: 12px;
}

/* 批量操作按钮 */
.batch-operation .el-button {
  padding: 6px 16px;
  font-size: 14px;
}

/* 收藏商品网格 */
.favorites-grid {
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 20px;
}

.favorite-card {
  border: 1px solid #e8e8e8;
  border-radius: 8px;
  overflow: hidden;
  transition: all 0.3s ease;
  position: relative;
}

/* 选择圆圈样式 */
.select-circle-wrapper {
  position: absolute;
  top: 10px;
  right: 10px;
  z-index: 10;
  /* background-color: rgba(255, 255, 255, 0.9);
  border-radius: 50%; */
  padding: 2px;
}

.product-image {
  width: 100%;
  height: 180px;
  overflow: hidden;
}

.product-image img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  transition: transform 0.3s ease;
}

.favorite-card:hover {
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
  transform: translateY(-2px);
}

.favorite-card:hover .product-image img {
  transform: scale(1.05);
}

.product-info {
  padding: 12px;
}

.product-name {
  font-size: 14px;
  color: #333333;
  margin-bottom: 10px;
  height: 40px;
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  line-clamp: 2;
  -webkit-box-orient: vertical;
  text-align: left;
}

.product-price {
  display: flex;
  align-items: center;
  justify-content: space-between;
  font-size: 16px;
  color: #ff4d4f;
  font-weight: 600;
  margin-bottom: 5px;
}

.price-symbol {
  font-size: 12px;
}

.price-unit {
  font-size: 12px;
  margin-left: 2px;
}

.product-sales {
  font-size: 12px;
  color: #999999;
}


/* 隐藏复选框的label文本 */
:deep(.el-checkbox__label) {
  display: none;
}

/* 分页容器 */
.pagination-container {
  background-color: #ffffff;
  border-radius: 8px;
  padding: 20px;
  box-shadow: 0 2px 12px rgba(0, 0, 0, 0.05);
  text-align: right;
  text-align: center;

}

/* 响应式设计 */
@media (max-width: 768px) {
  .favorites-grid {
    grid-template-columns: repeat(2, 1fr);
  }

  .section-header {
    flex-direction: column;
    align-items: flex-start;
    gap: 12px;
  }
}

@media (max-width: 480px) {
  .favorites-grid {
    grid-template-columns: 1fr;
  }
}
</style>